import { normalizeEnrollmentStatus } from './enrollmentStatus'
import { SAO_PAULO_TIMEZONE } from './saoPauloDateTime'

export function getSaoPauloDatePart(value) {
  if (!value) return ''
  try {
    return new Intl.DateTimeFormat('sv-SE', {
      timeZone: SAO_PAULO_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(value))
  } catch {
    return ''
  }
}

export function computeDaysBetween(startYmd, endYmd) {
  if (!startYmd || !endYmd) return ''
  const start = new Date(`${startYmd}T00:00:00-03:00`)
  const end = new Date(`${endYmd}T00:00:00-03:00`)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return ''
  const diffMs = end.getTime() - start.getTime()
  const days = Math.ceil(diffMs / (24 * 60 * 60 * 1000))
  return days >= 0 ? days : ''
}

export function addDaysToYmd(startYmd, days) {
  if (!startYmd) return ''
  const parsedDays = Number.parseInt(days, 10)
  if (!Number.isFinite(parsedDays) || parsedDays < 0) return ''
  const start = new Date(`${startYmd}T00:00:00-03:00`)
  if (Number.isNaN(start.getTime())) return ''
  const end = new Date(start.getTime() + (parsedDays * 24 * 60 * 60 * 1000))
  return getSaoPauloDatePart(end)
}

export function buildIsoFromYmdStartOfDay(ymdDateStr) {
  if (!ymdDateStr) return null
  const iso = new Date(`${ymdDateStr}T00:00:00.000-03:00`)
  return Number.isNaN(iso.getTime()) ? null : iso.toISOString()
}

export function buildIsoFromYmdEndOfDay(ymdDateStr) {
  if (!ymdDateStr) return null
  const iso = new Date(`${ymdDateStr}T23:59:59.999-03:00`)
  return Number.isNaN(iso.getTime()) ? null : iso.toISOString()
}

export function buildEnrollmentEditFormState(enrollment) {
  const startDate = getSaoPauloDatePart(enrollment?.confirmed_at || enrollment?.created_at)
  const endDate = getSaoPauloDatePart(enrollment?.expires_at)
  return {
    startDate,
    endDate,
    validityDays: computeDaysBetween(startDate, endDate),
  }
}

export function resolveUserLifecycleStatusForEnrollmentPeriod({
  currentStatus,
  startDate,
  todayDate,
}) {
  const normalizedCurrentStatus = String(currentStatus || '').trim()
  if (!normalizedCurrentStatus) return ''
  if (!startDate || !todayDate) return normalizedCurrentStatus

  if (normalizedCurrentStatus === 'Programado') {
    return startDate > todayDate ? 'Programado' : 'Pendente'
  }

  return normalizedCurrentStatus
}


export function getAdminEnrollmentStartAt(enrollment) {
  return enrollment?.confirmed_at || enrollment?.created_at || null
}

export function getAdminEnrollmentDisplayStatus(
  enrollmentStatus,
  userLifecycleStatus,
  expiresAt,
  startAt = null,
  todayDate = getSaoPauloDatePart(new Date())
) {
  const normalizedLifecycleStatus = String(userLifecycleStatus || '').trim()
  const startDate = getSaoPauloDatePart(startAt)
  const hasFutureStartDate = Boolean(startDate && todayDate && startDate > todayDate)

  // A matrícula só entra em vigor na data de início. Enquanto essa data não
  // chegar, ela deve ser exibida como "Programado", independentemente do
  // status do perfil do usuário (Ativo, Pendente etc.).
  if (hasFutureStartDate) {
    return 'Programado'
  }

  if (normalizedLifecycleStatus === 'Programado' || normalizedLifecycleStatus === 'Pendente') {
    return normalizedLifecycleStatus
  }

  return normalizeEnrollmentStatus(enrollmentStatus, expiresAt)
}

export function getEnrollmentEditSubmitLabel(isEditing) {
  return isEditing ? 'Salvar Alterações' : 'Confirmar Matrícula'
}
